module.exports = __webpack_public_path__ + "b88f14d15c8385788fbc0f22341fbd3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/non-accommodation-with-color.svg
// module id = 1533
// module chunks = 1 6